import { produce, Draft } from 'immer'
import {
  SET_LOCKERS_DATA,
  FETCH_LOCKERS_REQUEST,
  SET_LOCKER_DETAIL_DATA,
  FETCH_LOCKER_DETAIL_REQUEST,
} from './types'
import {
  setLockersData,
  fetchLockersDataRequest,
  setLockerDetailData,
  fetchLockerDetailRequest,
} from './actions'
import { Lockers, NormalizedLockers, LockerDetail } from './models'

export type LockersState = Readonly<{
  data: {
    result: Lockers['_id'][]
    entities: NormalizedLockers
  }
}>

export type LockerDetailState = Readonly<{ data: { result: LockerDetail } }>

const initialState = {
  data: { result: [], entities: {} },
}

export const lockersReducer = produce(
  (
    draft: Draft<LockersState>,
    action: ReturnType<typeof setLockersData> | ReturnType<typeof fetchLockersDataRequest>
  ) => {
    switch (action.type) {
      case FETCH_LOCKERS_REQUEST:
        draft
        break
      case SET_LOCKERS_DATA:
        draft.data.result = action.payload.lockers.result
        draft.data.entities = action.payload.lockers.entities
        break
      default:
        draft
    }
  },
  initialState
)

export const lockerDetailReducer = produce(
  (
    draft: Draft<LockerDetailState>,
    action: ReturnType<typeof setLockerDetailData> | ReturnType<typeof fetchLockerDetailRequest>
  ) => {
    switch (action.type) {
      case FETCH_LOCKER_DETAIL_REQUEST:
        draft
        break
      case SET_LOCKER_DETAIL_DATA:
        draft.data.result = action.payload.lockerDetail.result
        break
      default:
        draft
    }
  },
  initialState
)
